@if (iconName) {
    <bizz-icon class="text-danger size-4 cursor-pointer hover:text-red-700" [iconName]="iconName"
               (click)="onIconClick($event)">
    </bizz-icon>
}

